import { Col } from "reactstrap";
import LoginForm from "../Common/LoginForm";
import { dynamicImage } from "../../../Service/DynamicImage";
import RatioImage from "../../../CommonElements/RatioImage";

const LoginWithBgImageContainer = () => {
  return (
    <>
      <Col xl="7" className="p-0">
        <RatioImage className="bg-img-cover bg-center img-fluid w-100 " src={dynamicImage("login/2.jpg")} alt="looginpage" />
      </Col>
      <Col xl="5" className="p-0">
        <div className="login-card login-dark">
          <LoginForm required logoClass="text-start" />
        </div>
      </Col>
    </>
  );
};

export default LoginWithBgImageContainer;
